import { render, staticRenderFns } from "./TransactionDocumentSyncDetails.vue?vue&type=template&id=5f75b80c&"
import script from "./TransactionDocumentSyncDetails.vue?vue&type=script&lang=ts&"
export * from "./TransactionDocumentSyncDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports